.header {
  display: flex;
  gap: 23px;
  align-items: center;
  justify-content: start;
  height: 56px;
  padding-inline: 17px;
  background-color: var(--color-white);
}

.logoIcon {
  width: 79px;
  height: 15px;
}

.pageTitle {
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
  color: rgb(0 0 0 / 60%);
}

.control {
  display: flex;
  justify-content: center;
  padding-block: 8px;
  border-top: 1px solid rgb(0 0 0 / 12%);
}
